import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Location } from '@/models/location.model';

class LocationsService extends BaseService {
  private url: string = '/api/location';

  constructor() {
    super();
  }

  public async findCoordinates(
    search: string,
  ): Promise<DataResponse<{ lat: 0; lng: 0 }>> {
    const res = await this.$http.post<{ lat: 0; lng: 0 }>(
      `${this.url}/coordinates`,
      {
        search,
      },
    );

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async create(item: Location): Promise<DataResponse<Location>> {
    const res = await this.$http.post<Location>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async update(item: Location): Promise<DataResponse<Location>> {
    const res = await this.$http.put<Location>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async get(id: number): Promise<DataResponse<Location>> {
    const res = await this.$http.get<Location>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Location[]>> {
    const res = await this.$http.get<Location[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new LocationsService();
